import { List, ListItem, ListItemText } from '@mui/material';

import type { Proposal } from 'api/projectVersioning/types';

import { ProposalListRow } from './ProposalListRow';
import { buildProposalSecondaryText } from './utils/buildProposalSecondaryText';

type HistoryProposalsListProps = {
  proposals: Proposal[];
};

export const HistoryProposalsList: React.FC<HistoryProposalsListProps> = ({ proposals }) => (
  <List>
    {proposals.length > 0 ? (
      proposals.map((proposal) => (
        <ProposalListRow
          key={proposal.id}
          proposal={proposal}
          secondaryText={buildProposalSecondaryText(proposal)}
          variant='history'
        />
      ))
    ) : (
      <ListItem>
        <ListItemText secondary="There's no proposal history yet. Your merged and discarded proposals will appear here once available." />
      </ListItem>
    )}
  </List>
);
